(function () {
  function winterEscapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function winterNormalizeLocale(locale) {
    return String(locale || '').toLowerCase().split('-')[0];
  }

  function winterDocumentLabel(type) {
    const map = {
      PRODUCT_CATALOGUE: 'Produktkatalog',
      PRODUCT_SHEET: 'Produktblad',
      INSTALLATION_MANUAL: 'Installationsmanual',
      USER_MANUAL: 'Användarmanual',
      DECLARATION_OF_PERFORMANCE: 'Prestandadeklaration',
      SAFETY_DATA_SHEET: 'Säkerhetsdatablad'
    };

    return map[type] || String(type || '').replace(/_/g, ' ');
  }

  function winterReplaceInnerHTML(selector, html) {
    const currentNode = document.querySelector(selector);
    if (!currentNode) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newNode = doc.querySelector(selector);

    if (newNode) {
      currentNode.innerHTML = newNode.innerHTML;
    }
  }

  async function winterGetCart() {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
      throw new Error('Could not fetch cart');
    }

    return response.json();
  }

  async function winterRefreshCartUI(cart) {
    const sectionIds = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text'];
    const url = `${window.Shopify.routes.root}?sections=${sectionIds.join(',')}`;

    const response = await fetch(url, {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
      throw new Error('Could not refresh cart sections');
    }

    const sections = await response.json();

    if (sections['cart-drawer']) {
      winterReplaceInnerHTML('#CartDrawer', sections['cart-drawer']);
      winterReplaceInnerHTML('cart-drawer', sections['cart-drawer']);
    }

    if (sections['cart-icon-bubble']) {
      winterReplaceInnerHTML('#cart-icon-bubble', sections['cart-icon-bubble']);
      winterReplaceInnerHTML('.cart-count-bubble', sections['cart-icon-bubble']);
    }

    if (sections['cart-live-region-text']) {
      winterReplaceInnerHTML('#cart-live-region-text', sections['cart-live-region-text']);
    }

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: { cart }
      })
    );

    document.dispatchEvent(
      new CustomEvent('winter:cart-updated', {
        detail: { cart }
      })
    );

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  }

  function winterRenderDocuments() {
    document.querySelectorAll('[data-winter-documents-root]').forEach((root) => {
      const script = root.querySelector('[data-winter-documents-json]');
      const output = root.querySelector('[data-winter-documents-output]');

      if (!script || !output) return;

      try {
        const data = JSON.parse(script.textContent.trim());

        if (!Array.isArray(data) || data.length === 0) {
          root.closest('.winter-pi-block')?.remove();
          return;
        }

        let html = '';

        data.forEach((doc) => {
          const url = doc.cdn_url || doc.origin_url;
          if (!url) return;

          const label = winterDocumentLabel(doc.document_type);
          const lang = doc.language && doc.language.code ? String(doc.language.code).toUpperCase() : '';
          const target = root.dataset.openInNewTab === 'true' ? '_blank' : '_self';
          const rel = target === '_blank' ? ' rel="noopener noreferrer"' : '';

          html += `
            <a class="winter-document-item" href="${winterEscapeHtml(url)}" target="${target}"${rel}>
              <span class="winter-document-item__icon">📄</span>
              <span class="winter-document-item__content">
                <span class="winter-document-item__title">${winterEscapeHtml(label)}</span>
                ${lang ? `<span class="winter-document-item__meta">(${winterEscapeHtml(lang)})</span>` : ''}
              </span>
            </a>
          `;
        });

        if (!html) {
          root.closest('.winter-pi-block')?.remove();
          return;
        }

        output.innerHTML = html;
      } catch (error) {
        console.error('Documents error', error);
        root.closest('.winter-pi-block')?.remove();
      }
    });
  }

  function winterRenderKeyvals() {
    const roots = document.querySelectorAll('[data-winter-keyvals-root]');

    roots.forEach((root) => {
      const script = root.querySelector('[data-winter-keyvals-json]');
      const output = root.querySelector('[data-winter-keyvals-output]');
      const locale = winterNormalizeLocale(root.getAttribute('data-locale'));

      if (!script || !output) return;

      try {
        const raw = script.textContent.trim();
        const data = JSON.parse(raw);

        if (!Array.isArray(data) || data.length === 0) {
          root.closest('.winter-pi-block')?.remove();
          return;
        }

        const preferredLanguage = locale === 'sv' ? 'sv' : 'en';
        const groupsToRender = data.filter((group) => {
          const lang = winterNormalizeLocale(group && group.language ? group.language : '');
          return lang === preferredLanguage;
        });

        if (!groupsToRender.length) {
          root.closest('.winter-pi-block')?.remove();
          return;
        }

        let rows = '';

        groupsToRender.forEach((group) => {
          if (!group || !Array.isArray(group.key_value_pairs) || group.key_value_pairs.length === 0) {
            return;
          }

          const header = group.header ? String(group.header).replace(/\.1$/, '') : '';

          if (header) {
            rows += `
              <tr class="winter-pi-table__group-row">
                <td colspan="2">${winterEscapeHtml(header)}</td>
              </tr>
            `;
          }

          group.key_value_pairs.forEach((pair) => {
            const key = pair && pair.key ? pair.key : '';
            const value = pair && pair.value ? pair.value : '';

            if (key || value) {
              rows += `
                <tr>
                  <th>${winterEscapeHtml(key)}</th>
                  <td>${winterEscapeHtml(value)}</td>
                </tr>
              `;
            }
          });
        });

        if (!rows) {
          root.closest('.winter-pi-block')?.remove();
          return;
        }

        output.innerHTML = `
          <div class="winter-pi-table-wrap">
            <table class="winter-pi-table">
              <tbody>
                ${rows}
              </tbody>
            </table>
          </div>
        `;
      } catch (error) {
        console.error('Winter key values parse error', error);
        root.closest('.winter-pi-block')?.remove();
      }
    });
  }

  function winterInit() {
    winterRenderDocuments();
    winterRenderKeyvals();
  }

  document.addEventListener('click', function (event) {
    const openBtn = event.target.closest('[data-winter-addon-open]');
    const closeBtn = event.target.closest('[data-winter-addon-close]');
    const backdrop = event.target.closest('.winter-addon-modal__backdrop');

    if (openBtn) {
      const modalId = openBtn.getAttribute('data-winter-addon-open');
      const modal = document.getElementById(modalId);

      if (modal) {
        modal.hidden = false;
        document.documentElement.classList.add('winter-modal-open');
        document.body.style.overflow = 'hidden';
      }

      return;
    }

    if (closeBtn || backdrop) {
      const modal =
        event.target.closest('.winter-addon-modal') ||
        document.querySelector('.winter-addon-modal:not([hidden])');

      if (modal) {
        modal.hidden = true;
        document.documentElement.classList.remove('winter-modal-open');
        document.body.style.overflow = '';
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      const modal = document.querySelector('.winter-addon-modal:not([hidden])');

      if (modal) {
        modal.hidden = true;
        document.documentElement.classList.remove('winter-modal-open');
        document.body.style.overflow = '';
      }
    }
  });

  document.addEventListener('change', function (event) {
    const select = event.target.closest('[data-winter-variant-select]');
    if (!select) return;

    const form = select.closest('form');
    if (!form) return;

    let hiddenVariantInput = form.querySelector('input[name="id"]');

    if (!hiddenVariantInput) {
      hiddenVariantInput = document.createElement('input');
      hiddenVariantInput.type = 'hidden';
      hiddenVariantInput.name = 'id';
      form.appendChild(hiddenVariantInput);
    }

    hiddenVariantInput.value = select.value;

    const option = select.options[select.selectedIndex];
    const modalContent = form.closest('.winter-addon-modal__content');
    const priceContainer = modalContent ? modalContent.querySelector('[data-winter-price]') : null;

    if (priceContainer && option.dataset.price) {
      priceContainer.textContent = option.dataset.price;
    }
  });

  document.addEventListener('submit', async function (event) {
    const form = event.target.closest('[data-winter-addon-atc]');
    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;

    const idField = form.querySelector('[name="id"]');
    const quantityField = form.querySelector('[name="quantity"]');

    const variantId = idField ? Number(idField.value) : null;
    const quantity = quantityField ? Number(quantityField.value) || 1 : 1;

    if (!variantId) {
      console.error('Missing variant id for addon add-to-cart');
      return;
    }

    const originalText = button.textContent;

    try {
      button.disabled = true;
      button.textContent = 'Lägger till...';

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: quantity
            }
          ]
        })
      });

      const data = await response.json();

      if (!response.ok) {
        console.error('Add to cart failed', data);
        throw new Error(data.description || data.message || 'Kunde inte lägga till produkten i varukorgen.');
      }

      const cart = await winterGetCart();
      await winterRefreshCartUI(cart);

      button.textContent = 'Tillagd';

      document.dispatchEvent(
        new CustomEvent('winter:addon-added-to-cart', {
          detail: {
            variantId,
            quantity,
            response: data,
            cart
          }
        })
      );

      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 1200);
    } catch (error) {
      console.error(error);
      button.textContent = 'Något gick fel';

      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 1500);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', winterInit, { once: true });
  } else {
    winterInit();
  }
})();

function winterResolveVideoUrl(item) {
  return (
    item?.url ||
    item?.video_url ||
    item?.src ||
    item?.cdn_url ||
    item?.origin_url ||
    item?.file ||
    ''
  );
}

function winterResolveVideoTitle(item, index) {
  return item?.title || item?.name || item?.label || `Video ${index + 1}`;
}

function winterRenderVideos() {
  document.querySelectorAll('[data-winter-videos-root]').forEach((root) => {
    const script = root.querySelector('[data-winter-videos-json]');
    const output = root.querySelector('[data-winter-videos-output]');
    const emptyText = root.getAttribute('data-empty-text') || 'Inga videos tillgängliga.';
    const layout = root.getAttribute('data-layout') || 'grid';

    if (!script || !output) return;

    try {
      const data = JSON.parse(script.textContent.trim());

      if (!Array.isArray(data) || data.length === 0) {
        root.closest('.winter-pi-block')?.remove();
        return;
      }

      let items = '';

      data.forEach((item, index) => {
        const url = winterResolveVideoUrl(item);
        if (!url) return;

        const title = winterResolveVideoTitle(item, index);

        items += `
          <div class="winter-video-card">
            <div class="winter-video-card__media">
              <video controls playsinline preload="metadata">
                <source src="${winterEscapeHtml(url)}">
              </video>
            </div>
            <div class="winter-video-card__content">
              <div class="winter-video-card__title">${winterEscapeHtml(title)}</div>
            </div>
          </div>
        `;
      });

      if (!items) {
        root.closest('.winter-pi-block')?.remove();
        return;
      }

      output.innerHTML = `
        <div class="winter-videos__track winter-videos__track--${winterEscapeHtml(layout)}">
          ${items}
        </div>
      `;
    } catch (error) {
      console.error('Winter videos parse error', error);
      root.closest('.winter-pi-block')?.remove();
    }
  });
}

document.addEventListener('DOMContentLoaded', winterRenderVideos);
winterRenderVideos();